import React from 'react';
export var VariantContext = /*#__PURE__*/React.createContext();
export var MenuContext = /*#__PURE__*/React.createContext({
  schedules: [],
  categories: [],
  items: [],
  modifiers_sets: [],
  modifiers: [],
  disableModifiers: false,
  disableScheduleAvailability: false,
  disableSchedules: false,
  showMenuLikes: true,
  showCategoryDropdown: true,
  displayZeroCostItemPrices: false,
  displayZeroCostModifierPrices: false,
  business: {}
});
export var FoodMenuCartContext = /*#__PURE__*/React.createContext();
export var VariantProvider = VariantContext.Provider;
export var VariantConsumer = VariantContext.Consumer;
export var MenuProvider = MenuContext.Provider;
export var MenuConsumer = MenuContext.Consumer;
export var FoodMenuCartProvider = FoodMenuCartContext.Provider;